import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Search } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled 
        ? 'bg-white/70 backdrop-blur-xl shadow-lg' 
        : 'bg-white/95 backdrop-blur-sm shadow-sm'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_kargo-pouch/artifacts/mez3d6kq_logo2.png" 
              alt="KargoPack Logo" 
              className="h-14 w-auto transition-all duration-300"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-[#E31E24] transition-colors font-semibold">
              Ana Sayfa
            </Link>
            <Link to="/urunler" className="text-gray-700 hover:text-[#E31E24] transition-colors font-semibold">
              Ürünler
            </Link>
            <Link to="/hakkimizda" className="text-gray-700 hover:text-[#E31E24] transition-colors font-semibold">
              Hakkımızda
            </Link>
            <Link to="/surdurulebilirlik" className="text-gray-700 hover:text-[#E31E24] transition-colors font-semibold">
              Sürdürülebilirlik
            </Link>
            <Link to="/blog" className="text-gray-700 hover:text-[#E31E24] transition-colors font-semibold">
              Blog
            </Link>
            <Link to="/iletisim" className="text-gray-700 hover:text-[#E31E24] transition-colors font-semibold">
              İletişim
            </Link>
          </div>

          {/* Right Side Actions */}
          <div className="hidden md:flex items-center space-x-4">
            <Button variant="ghost" size="icon" className="rounded-full">
              <Search className="h-5 w-5" />
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100"
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-4 py-6 space-y-4">
            <Link 
              to="/" 
              className="block py-2 text-gray-700 hover:text-[#E31E24] transition-colors font-semibold"
              onClick={() => setMobileMenuOpen(false)}
            >
              Ana Sayfa
            </Link>
            <Link 
              to="/urunler" 
              className="block py-2 text-gray-700 hover:text-[#E31E24] transition-colors font-semibold"
              onClick={() => setMobileMenuOpen(false)}
            >
              Ürünler
            </Link>
            <Link 
              to="/hakkimizda" 
              className="block py-2 text-gray-700 hover:text-[#E31E24] transition-colors font-semibold"
              onClick={() => setMobileMenuOpen(false)}
            >
              Hakkımızda
            </Link>
            <Link 
              to="/surdurulebilirlik" 
              className="block py-2 text-gray-700 hover:text-[#E31E24] transition-colors font-semibold"
              onClick={() => setMobileMenuOpen(false)}
            >
              Sürdürülebilirlik
            </Link>
            <Link 
              to="/blog" 
              className="block py-2 text-gray-700 hover:text-[#E31E24] transition-colors font-semibold"
              onClick={() => setMobileMenuOpen(false)}
            >
              Blog
            </Link>
            <Link 
              to="/iletisim" 
              className="block py-2 text-gray-700 hover:text-[#E31E24] transition-colors font-semibold"
              onClick={() => setMobileMenuOpen(false)}
            >
              İletişim
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
